import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { LogoMark } from './LogoMark';
interface Props {
  title: string;
  lastUpdated: string;
  children: ReactNode;
}
export function LegalPage({
  title,
  lastUpdated,
  children
}: Props) {
  return <div className="min-h-screen flex flex-col w-full bg-ink font-sans text-bone selection:bg-mint selection:text-ink" data-id="element-250">
      {/* Minimal top bar */}
      <header className="border-b border-white/5" data-id="element-251">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between" data-id="element-252">
          <Link to="/" className="flex items-center gap-3" data-id="element-253">
            <LogoMark size={32} data-id="element-254" />
            <div className="flex items-baseline gap-1.5" data-id="element-255">
              <span className="font-semibold text-lg text-bone tracking-tight" data-id="element-256">
                Masube
              </span>
              <span className="text-xs font-medium text-mint uppercase tracking-[0.2em]" data-id="element-257">
                Settle
              </span>
            </div>
          </Link>
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-bone-dim hover:text-bone transition-colors" data-id="element-258">
            
            <ArrowLeft className="w-4 h-4" data-id="element-259" />
            Back to home
          </Link>
        </div>
      </header>

      <main className="flex-1" data-id="element-260">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-261">
          <h1 className="display text-bone mb-3" style={{
          fontSize: 'clamp(2.25rem, 5vw, 3.5rem)'
        }} data-id="element-262">
            
            {title}
          </h1>
          <p className="text-sm text-muted mb-12" data-id="element-263">Last updated {lastUpdated}</p>

          <div className="legal-content space-y-8 text-bone-dim leading-relaxed" data-id="element-264">
            {children}
          </div>
        </div>
      </main>

      <footer className="border-t border-white/5 py-8" data-id="element-265">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row justify-between items-center gap-3 text-sm text-muted" data-id="element-266">
          <span data-id="element-267">© {new Date().getFullYear()} Masube Settle (Pty) Ltd.</span>
          <div className="flex gap-6" data-id="element-268">
            <Link to="/privacy" className="hover:text-bone transition-colors" data-id="element-269">
              Privacy
            </Link>
            <Link to="/terms" className="hover:text-bone transition-colors" data-id="element-270">
              Terms
            </Link>
          </div>
        </div>
      </footer>
    </div>;
}
// Shared building blocks for legal copy
export function LegalSection({
  heading,
  children
}: {
  heading: string;
  children: ReactNode;
}) {
  return <section data-id="element-271">
      <h2 className="text-xl font-semibold text-bone mb-3 tracking-tight" data-id="element-272">
        {heading}
      </h2>
      <div className="space-y-3" data-id="element-273">{children}</div>
    </section>;
}